import styled from 'styled-components'

export const FlexRight = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`